module.exports = __webpack_public_path__ + "static/browserstack-f54de772b32457c6b9f3535acb6d6e66.png";